var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.554688 10.1765V11.5882C0.554688 11.9627 0.703427 12.3217 0.968184 12.5865C1.23294 12.8513 1.59203 13 1.96645 13H10.437C10.8115 13 11.1706 12.8513 11.4353 12.5865C11.7001 12.3217 11.8488 11.9627 11.8488 11.5882V10.1765M2.67233 5.94118L6.20175 9.47059M6.20175 9.47059L9.73116 5.94118M6.20175 9.47059V1",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.400c2c970bb4ec81f4978b15c98407ab.svg";
export { ForwardRef as ReactComponent };